import { createContext, useReducer, useContext, useEffect } from "react";
import { INIT_STATE, reducer } from "./reducers/data-lists-reducer";
import { setDataList } from "./action-reducers";
import { getProcedures, getBranches, getUsers } from "../api/api";
import { useSnackbar } from "notistack";

export const DataLists = createContext({});

export const DataListsContextProvider = ({ children }) => {
  const [lists, dataListDispatch] = useReducer(reducer, INIT_STATE);
  const { enqueueSnackbar } = useSnackbar();

  
  const getDataList = async () => {
    const [users_res, branches_res, procedures_res] = await Promise.all([
      getUsers("/users"),
      getBranches("/branches"),
      getProcedures("/procedures"),
    ]);
    const [users, users_err] = users_res;
    const [branches, branches_err] = branches_res;
    const [procedures, procedures_err] = procedures_res;


    if (!users_err) {
      const list = users.data.sort(
        (a, b) => a.FirstName.charCodeAt(0) - b.FirstName.charCodeAt(0)
      );
      dataListDispatch(setDataList(list, "users"));
    } else {
      enqueueSnackbar(`ERROR : ${users_err.message}`, {
        preventDuplicate: true,
        variant: "error",
      });
    }

    if (!branches_err) {
      const list = branches.data.sort(
        (a, b) => a.Prefix.charCodeAt(0) - b.Prefix.charCodeAt(0)
      );
      dataListDispatch(setDataList(list, "branches"));
    } else {
      enqueueSnackbar(`ERROR : ${branches_err.message}`, {
        preventDuplicate: true,
        variant: "error",
      });
    }

    if (!procedures_err) {
      const list = procedures.data.sort(
        (a, b) => a.Prefix.charCodeAt(0) - b.Prefix.charCodeAt(0)
      );
      dataListDispatch(setDataList(list, "procedures"));
    } else {
      enqueueSnackbar(`ERROR : ${procedures_err.message}`, {
        preventDuplicate: true,
        variant: "error",
      });
    }
  };

  useEffect(() => {
    getDataList();
  }, []);

  return (
    <DataLists.Provider value={{ lists, dataListDispatch }}>
      {children}
    </DataLists.Provider>
  );
};

export const useDataLists = () => useContext(DataLists);
